<template>
  <div class="base-input-content">
    <label class="base-input-label" aria-hidden="true">
      <slot name="label-icon" />
      <span class="base-input-label-text">
        <slot name="label-text" />
      </span>
    </label>
    <input
      style="width: 100%"
      class="base-input"
      :modelValue="modelValue"
      :value.sync="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: "",
    },
    display: {
      Type: String,
      default: "",
    },
  },
};
</script>

<style lang="css" scoped>
.base-input-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.base-input-content {
  padding: 0 0.5rem;
  display: v-bind("display");
}
.base-input {
  width: 100%;
  padding: 12px 20px;
  margin: 0.2rem 0;
  display: inline-block;
  border: 1px solid #ccc;
  background-color: #f7f7f7;
  border-radius: 0.5rem;
  box-sizing: border-box;
  transition: all 0.3s;
}
.base-input:focus {
  background-color: #fff;
  border: 1px solid rgb(0, 183, 255);
}
.base-input-label-text {
  font-size: 0.7rem;
}
/* input:optional {
  border-color: gray;
}
input:required {
  border-color: black;
}
input:invalid {
  border-color: red;
} */
</style>
